module.exports = __webpack_public_path__ + "img/17349907.da2c9537.png";